module.exports = __webpack_public_path__ + "img/bg.a5024174.png";